import { SmButton } from '@smiles/smiles-react-design-system';
import React from 'react';

import useApi from '@/hooks/useApi';
import useEvent from '@/hooks/useEvent';

import { TOptinContent } from '@/services/requests/Liferay/types';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { THttpService } from '@/services/HttpService';

type TProps = {
  data: TOptinContent;
  onClose: () => void;
};

const handleClose = (
  _closeFunction: () => void,
  event: { data: any; isOpen?: boolean; close?: () => void },
  ApiInteractions: THttpService,
) => {
  dispatchInteraction(ApiInteractions, 'extra_optin_click_close', {
    recommendationId: event.data.recommendationId,
  });

  _closeFunction();
};

export function ScreenSuccess({ data, onClose }: TProps) {
  const { ApiInteractions } = useApi();
  const event = useEvent();
  return (
    <div className="smls-optin__modal-content">
      <div className="smls-optin__button--close">
        <SmButton
          onClick={() => handleClose(onClose, event, ApiInteractions)}
          isPill
          isOutlined
          icon={<span className="material-icons">close</span>}
        />
      </div>
      <img
        className="smls-optin__image"
        src={data.success.success_image}
        alt={data.success.success_title}
      />
      <h4 className="smls-optin__title">{data.success.success_title}</h4>
      <SmButton
        className="smls-optin__button--send"
        onClick={() => handleClose(onClose, event, ApiInteractions)}
        text={data.success.success_button_label}
      />
    </div>
  );
}
